import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import menuReducer from "../features/menuSlice";
import paisReducer from "../features/paisSlice";
import ciudadReducer from "../features/ciudadSlice";
import clienteReducer from "../features/clienteSlice";
import serviciosReducer from "../features/serviciosSlice"
import facturaVentaReducer from "../features/facturaVentaSlice";
import reportesReducer from "../features/reportesSlice"
import configuracionesReducer from "../features/configuracionesSlice"
import personaReducer from "../features/personaSlice";
import rolReducer from "../features/rolSlice";
import permisoReducer from "../features/permisoSlice";
import usuarioReducer from "../features/usuarioSlice";
import presupuestoReducer from "../features/presupuestoSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        menu: menuReducer,
        paises : paisReducer,
        ciudades : ciudadReducer,
        clientes : clienteReducer,
        servicios : serviciosReducer,
        facturas : facturaVentaReducer,
        reportes : reportesReducer,
        configuraciones : configuracionesReducer,
        persona: personaReducer,
        rol: rolReducer,
        permiso: permisoReducer,
        usuario: usuarioReducer,
        presupuestos: presupuestoReducer,
    },
})